<template>
  <div class="table-footer">
    <div class="footer-content">
      <div>
        <slot name="pagination" />
      </div>

      <div class="flex items-center gap-8">
        <slot name="extra" />
        <div class="flex items-center gap-2">
          <div class="footer-info hidden lg:block">
            {{ $t("Результатов на странице") }}:
          </div>
          <Select
            :model-value="String(localPageSize)"
            @update:model-value="handlePageSizeChange"
          >
            <SelectTrigger class="w-[85px] h-8" :clearable="false">
              <SelectValue placeholder="10" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem
                v-for="size in pageSizes"
                :key="size"
                :value="String(size)"
              >
                {{ size }}
              </SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/ui/select";

export default {
  name: "TableFooterWrapper",
  components: { Select, SelectContent, SelectItem, SelectTrigger, SelectValue },
  props: {
    total: { type: Number, required: true },
    pageSize: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    pageSizes: { type: Array, default: () => [5, 10, 20] },
  },
  emits: ["update:pageSize", "update:currentPage"],
  data() {
    return {
      localPageSize: this.pageSize,
    };
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.localPageSize);
    },
  },
  methods: {
    handleNextPage() {
      if (this.currentPage < this.maxPage) {
        this.$emit("update:currentPage", this.currentPage + 1);
      }
    },
    handlePageSizeChange(val) {
      const size = Number(val);
      this.localPageSize = size;
      this.$emit("update:pageSize", size);
      this.$emit("update:currentPage", 1);
    },
  },
  watch: {
    pageSize(val) {
      this.localPageSize = val;
    },
  },
};
</script>

<style scoped lang="scss">
.table-footer {
  @apply w-full border bg-card;
  border-top: none;
  padding: 12px 20px;
  border-color: hsl(var(--border));
}

.footer-content {
  @apply min-h-[38px] flex items-center justify-between flex-wrap gap-4;
}

.footer-info {
  @apply text-sm text-muted-foreground;
  letter-spacing: 0.2px;
}

@media (max-width: 1500px) {
  .footer-info {
    @apply hidden !important;
  }
}
</style>
